// extracted by mini-css-extract-plugin
export default {"modal-body":"vvgbg9gj7jwaps9wx+hNJg=="};